export function getAll() {
  return [
    {
      type: 4,
      name: "Basic",
      text: "基本資料",
    },
    {
      type: 7,
      name: "Module",
      text: "模組設定",
    },
    {
      type: 5,
      name: "Report",
      text: "報表",
    },
    {
      type: 8,
      name: "Customer",
      text: "會員",
    },
    {
      type: 10,
      name: "ERP",
      text: "進銷存",
    },
    {
      type: 12,
      name: "Account",
      text: "帳款",
    },
    {
      type: 9,
      name: "Cloud",
      text: "雲端",
    },
    {
      type: 14,
      name: "Other",
      text: "其他",
    },
    {
      type: 15,
      name: "ZiShun",
      text: "自順",
    },
    {
      type: 16,
      name: "HomePage",
      text: "首頁",
    },
  ];
}
